import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
//import { ReactComponent as Line } from '../../../assets/shape/line.svg';
import { ReactComponent as FocusedCircle } from '../../assets/shape/focusedcircle.svg';
import Pagination from '../../components/Pagination';
import LoadingSpinner from '../../components/LoadingSpinner';
import axiosInstance from '../../api/axios-instance';
import SidebarMobile from './SidebarMobile';

type DancerType = {
  id: number;
  dancerName: string;
  images: string[];
};

type GenreType = {
  id: number;
  name: string;
};

const ClassBoard: React.FC = () => {
  const genres: GenreType[] = [
    { id: 1, name: '힙합' },
    { id: 2, name: '걸스힙합' },
    { id: 3, name: '팝핑' },
    { id: 4, name: '락킹' },
    { id: 5, name: '왁킹' },
    { id: 6, name: '걸리시/힐' },
    { id: 7, name: '크럼프' },
    { id: 8, name: '텃팅' },
    { id: 9, name: '코레오' },
    { id: 10, name: 'K-pop' }
  ];
  const [selectedGenre, setSelectedGenre] = useState<number>(1);
  const [data, setData] = useState<DancerType[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1); // 현재 페이지 상태
  const [totalElements, setTotalElements] = useState<number>(0); // 전체 요소 개수 상태 추가
  const [, setTotalPages] = useState<number>(1); // 전체 페이지 수
  const [isFetching, setIsFetching] = useState<boolean>(false); // 로딩 상태

  const perData = 6;

  useEffect(() => {
    // API 호출 함수
    const fetchData = async () => {
      setIsFetching(true); // 로딩 시작
      try {
        const genreId = selectedGenre;
        const response = await axiosInstance.get(
          `/dancers/genres/${genreId}?page=${currentPage}`
        );
        if (response.data.code === 200) {
          setData(response.data.data.dancers);
          setTotalPages(response.data.data.totalPages);
          setTotalElements(response.data.data.totalElements); // totalElements 추가
          console.log('댄서 데이터를 성공적으로 불러왔습니다.');
          console.log(response.data.data);
        } else {
          console.error('데이터를 불러오는 데 실패했습니다.');
        }
      } catch (error) {
        console.error('API 호출 중 오류 발생:', error);
      } finally {
        setIsFetching(false); // 로딩 종료
      }
    };
    fetchData();
  }, [selectedGenre, currentPage]);

  // 장르 선택 핸들러
  const handleGenreClick = (genre: number) => {
    setSelectedGenre(genre);
  };

  return (
    <Container>
      <SidebarContainer>
      <Sidebar>
        {genres.map((genre) => (
          <GenreWrapper
            key={genre.id}
            onClick={() => handleGenreClick(genre.id)}
          >
            {selectedGenre === genre.id && <FocusedCircle />}
            <Genre $isActive={selectedGenre === genre.id}>{genre.name}</Genre>
          </GenreWrapper>
        ))}
      </Sidebar>
      <SidebarMobile 
        genres={genres}
        selectedGenre={selectedGenre}
        onChange={handleGenreClick}
      />
      </SidebarContainer>
      <Line />
        <BoardContainer>
           {isFetching ? (
        <LoadingContainer>
          <LoadingSpinner isLoading={isFetching} />
        </LoadingContainer>
      ) : (
        <>
          <Classes>
            {data.map((dancer) => (
              <Class to={`/dancerprofile/${dancer.id}`} key={dancer.id}>
                <Image src={dancer.images[0]} alt={dancer.dancerName} />

                <Dancer>{dancer.dancerName}</Dancer>
              </Class>
            ))}
          </Classes>
          {/* <PaginationContainer> */}
          <Pagination
            dataLength={totalElements}
            perData={perData}
            currentPage={currentPage}
           setCurrentPage={setCurrentPage}
          />
          {/* </PaginationContainer> */}
          </>
      )}
      </BoardContainer>
    </Container>
  );
};

export default ClassBoard;


const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: black;
  align-items: center;
  padding-bottom: 140px;
  ${({ theme }) => theme.media.tablet} {
    flex-direction: row;
    align-items: flex-start;
    padding-bottom: 250px;
  }
`;
const Sidebar = styled.div`
   display: none;
   ${({ theme }) => theme.media.tablet} {
    display: flex;
    flex-direction: column;
    height: 620px;
    margin-top: 14px;
  }
`;
const SidebarContainer = styled.div`
`

const Line = styled.div`
  border: 2px solid var(--main_purple, #9819c3);
  //width: 343px;
  width: 90vw;
  height: 0px;
${({ theme }) => theme.media.tablet} {
    width: 0px;
    height: 770px;
    border: 2px solid var(--main_purple, #9819c3);
  }
    
  
`;
const GenreWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 150px;
  margin-bottom: 50px;

  &:hover {
    cursor: pointer;
  }
`;

const Genre = styled.div<{ $isActive: boolean }>`
  color: var(--text_secondary-gray, #b2b2b2);
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.9px;
  transition: all 0.3s ease;

  ${({ $isActive }) =>
    $isActive &&
     `
    margin-left: 13px;
    color: var(--main_white, #fff);
    font-size: 24px;
    font-weight: 600;
    letter-spacing: -1.2px;`}

`;


const BoardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  //justify-content: center;
  //width: 300px;
  margin-top: 69px;
  position: relative;
   ${({ theme }) => theme.media.tablet} {
  margin-top: 40px;
  margin-left: 100px;
  width: 740px;
  }
`;
const Classes = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  //width: 300px;
  max-height: 580px;
  margin-bottom: 88px;
  justify-items: center;
  align-items: start;
  gap: 61px;
   ${({ theme }) => theme.media.tablet} {
    width: 740px;
    height: 553px;
    gap: 100px;
    grid-template-columns: repeat(3, 1fr);
    margin-bottom: 120px;
  }
`;

const Class = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-decoration-line: none;
  /* margin-bottom: ; */
  width: 120px;
  height: 120px;
  &:hover {
    cursor: pointer;
  }
  ${({ theme }) => theme.media.tablet} {
     width: 180px;
    height: 180px;
  }
`;
const Image = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 7px;
  background: url(<path-to-image>) lightgray 50% / cover no-repeat;
  object-fit: cover;
    aspect-ratio: 1 / 1; 
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    aspect-ratio: 1 / 1; 
  }
   ${({ theme }) => theme.media.tablet} {
     width: 180px;
    height: 180px;
    border-radius: 7px;
  }
`;

const Dancer = styled.div`
  color: #fff;
  margin-top: 15px;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.9px;
    ${({ theme }) => theme.media.tablet} {
     font-size: 22px;
     letter-spacing: -1.1px;
  }
`;

 const LoadingContainer = styled.div`
   width: 880px;
 `;